import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })

export class SidebarService {

    private minWidth = 64;
    private maxWidth = 200;
    private toggleConpleteSubject: BehaviorSubject<any>;
    public toggleConplete: Observable<any>;
    
    constructor(){
      this.toggleConpleteSubject = new BehaviorSubject<any>(null);
      this.toggleConplete = this.toggleConpleteSubject.asObservable();
    }
    setMinMaxWidth(min:number, max:number){
      this.minWidth = min;
      this.maxWidth = max
    }
    
    getMinWith = ():number => this.minWidth

    onToggleConplete(){
      this.toggleConpleteSubject.next({});
    }

}
